import type { Maybe } from '@adornis/base/utilTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { registerEnum } from '@adornis/baseql/metadata/register.js';
import type { RegistrationStammdatenPlugin } from '@adornis/buchungsheld-db/db-plugins.js';
import { UserStammdaten } from '@adornis/buchungsheld-db/entities/stammdaten.js';
import { validate } from '@adornis/validation/decorators.js';
import { nonOptional } from '@adornis/validation/functions/nonOptional.js';

// ===== studiumdigitale - DigiTeLL =====

export const digitellRegistrationStammdatenPlugin: RegistrationStammdatenPlugin = {
  id: 'registration::stammdaten::digitell',
  type: 'registration::stammdaten',
  disableCustomFormfields: true,
  createStammdaten: async ({ userID, institutionID, createInDB } = {}) => {
    const stammdaten = new DIGITELLStammdaten({ userID, institutionID });
    if (createInDB) await stammdaten.create();
    return stammdaten;
  },
  getFields: () => {
    return Object.keys(DIGITELLStammdaten.fields).filter(
      it => !['_id', '_class', 'userID', 'institutionID'].includes(it),
    );
  },
  classType: () => DIGITELLStammdaten,
};

export enum DIGITELLConfirmEnum {
  DIGITELL_JA = 'DIGITELL_JA',
  DIGITELL_NEIN = 'DIGITELL_NEIN',
}
registerEnum({ enum: DIGITELLConfirmEnum, name: 'DIGITELLConfirmEnum' });

@Entity()
export class DIGITELLStammdaten extends UserStammdaten {
  static override _class = 'DIGITELLStammdaten';

  override getTranslationNamespace() {
    return 'digitell';
  }

  @Field(type => String)
  organisation: Maybe<string>;

  @Field(type => String)
  department: Maybe<String>;

  @validate(nonOptional())
  @Field(type => DIGITELLConfirmEnum)
  ichMchteAmMittagessenTeilnehmen: Maybe<DIGITELLConfirmEnum>;

  @validate(nonOptional())
  @Field(type => DIGITELLConfirmEnum)
  ichMchteAmAbendessenTeilnehmen: Maybe<DIGITELLConfirmEnum>;

  @Field(type => String)
  bitteTeilenSieUnsIhreBesonderenErnhrungsgewohnheitenUndAllergienMit: Maybe<string>;

  @Field(type => String)
  habenSieWeitereAnregungenWnscheBarrierefreiheitRuheraumEtc: Maybe<string>;

  @Field(type => DIGITELLConfirmEnum)
  ichBinDamitEinverstandenInDieTeilnehmerlisteAufgenommenZuWerden: Maybe<DIGITELLConfirmEnum>;

  @Field(type => DIGITELLConfirmEnum)
  ichBinEinverstandenDassAmVeranstaltungstagFotosUndVideosVonMirGemachtWerden: Maybe<DIGITELLConfirmEnum>;
}
